import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "postalCode", "address" ]

  async fillAddress() {
    const code = this.postalCodeTarget.value

    const url = new URL('/api/addresses', location.href);
    url.searchParams.set('postal_code', code);

    const res = await fetch(url);

    if (!res.ok) {
      alert('エラーが発生しました。時間を置いて再度お試しください。');
      return;
    }

    const addresses = await res.json();

    if (!addresses.length) {
      alert('住所は存在しません。');
      return;
    }

    this.addressTarget.value = addresses[0];
  }
}
